import { etapaProcessoOptions } from "@enums/EtapasProcesso/Index";

const EtapaProcesso = ({ etapaProcesso }) => {
    const option = etapaProcessoOptions.find(opt => opt.value === etapaProcesso);
    return option ? option.label : 'N/A';
};


export default EtapaProcesso;
